import { render } from "./CountryReadOnly.vue?vue&type=template&id=0f038a6f&scoped=true"
import script from "./CountryReadOnly.vue?vue&type=script&lang=js"
export * from "./CountryReadOnly.vue?vue&type=script&lang=js"

import "./CountryReadOnly.vue?vue&type=style&index=0&id=0f038a6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f038a6f"]])

export default __exports__